import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router";
import Section from "../../components/Section";
import { GET_FINALISTS_RATINGS_IN_JURIES_CARD } from "../../graphql_tags";

const FinishSection = styled(Section)`
  flex-direction: column;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const FinishCard = styled.div`
  display: grid;
  grid-template-columns: auto 228px;

  div {
    padding: 17px 20px;

    :nth-child(2),
    :nth-child(3) {
      text-align: center;
    }
  }
`;

const FinishFinalist = styled(FinishCard)`
  height: 86px;
  cursor: pointer;

  :not(:first-child) {
    height: 107px;

    > :first-child {
      margin-right: 3px;
    }

    > :last-child {
      margin-left: 3px;
    }
  }

  :nth-child(2) {
    > :first-child {
      border-top-left-radius: 10px;
    }

    > :last-child {
      border-top-right-radius: 10px;
    }
  }

  :last-child {
    > :first-child {
      border-bottom-left-radius: 10px;
    }

    > :last-child {
      border-bottom-right-radius: 10px;
    }
  }

  :not(:last-child) {
    margin-bottom: 3px;
  }

  div {
    background-color: #ffffff;
    color: #000000;

    p {
      font-weight: normal;
      font-size: 20px;
      line-height: 23px;
      margin: 0;
    }
  }
`;

const FinishHeader = styled(FinishCard)`
  div {
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;

    color: #777777;
  }
`;

export default () => {
  const { juries_id } = useParams();
  const [scores, setScores] = useState();
  const [juriesName, setJuriesName] = useState("");
  const [isLoaded, setLoaded] = useState(false);

  const getFinalistsByJuries = useQuery(GET_FINALISTS_RATINGS_IN_JURIES_CARD, {
    variables: { juries_id },
  });

  useEffect(() => {
    if (!getFinalistsByJuries.loading) {
      const { ratings, finalists, user } = getFinalistsByJuries.data;
      const a1 = ratings;
      const b1 = finalists;

      const mergedArray = (a1, b1) => {
        return a1.map((a2) => ({
          ...b1.find((b2) => b2.id === a2.finalists_id),
          ...a2,
        }));
      };

      setScores(mergedArray(a1, b1));
      setJuriesName(user.login);
      setLoaded(true);
    }
  }, [getFinalistsByJuries.loading, juries_id]);

  return (
    isLoaded && (
      <FinishSection>
        <FinishHeader>
          <div>{juriesName}</div>
        </FinishHeader>
        {scores.map(({ name, library, total, id }) => {
          return (
            <FinishFinalist key={id}>
              <div>
                <p>{name}</p>
                <p>{library}</p>
              </div>
              <div>
                <p>{total || "пропуск"}</p>
              </div>
            </FinishFinalist>
          );
        })}
      </FinishSection>
    )
  );
};
